export default {
  groupProfile(state: any): any {
    return state.groupProfile;
  },
  groupProfiles(state: any): any {
    return state.groupProfiles;
  },
  inviteGroup(state: any): string {
    return state.invitedGroup;
  },
};
